import { useState, useEffect } from 'react'
import Button from '@material-ui/core/Button'
import CancelOutlined from '@material-ui/icons/Clear'
import '../styles.css'
import axiosInstance from '../../utils/config'

function NewOrder(props) {
  const { display } = props,
    [formData, setFormData] = useState({
      clientName: '',
      Email: '',
      amountPaid: '',
      maximumDownloads: '',
      maximumContentAccess: '',
    }),
    [error, setError] = useState(''),
    [successMessage, setSuccessMessage] = useState(''),
    hidePopup = () => {
      props.setPopupDisplay('none')
      document.body.style.overflow = 'auto'
      setFormData({
        clientName: '',
        Email: '',
        amountPaid: '',
        maximumDownloads: '',
        maximumContentAccess: '',
      })
    },
    handleChange = (e) => {
      const { name, value } = e.target
      setFormData({ ...formData, [name]: value })
    },
    handleSubmit = async (e) => {
      e.preventDefault()
      let headers = {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage?.getItem('skiUserToken'),
      }
      await axiosInstance
        .get('/users/all', { headers })
        .then(async (res) => {
          let clients = [...res.data.data];
          let specificClient = clients.filter((client) =>
            client?.Email.toLowerCase().includes(
              formData.Email.toLowerCase(),
            ),
          );
          if (specificClient.length !== 0) {
            await axiosInstance
              .put(
                `/users/${specificClient[0]._id}/downloads/allocate`,
                {
                  amount: formData.amountPaid,
                  downloads: formData.maximumDownloads,
                },
                {
                  headers,
                },
              )
              .then((res) => {
                setError('')
                setSuccessMessage('Order successfully updated.')
                window.location.reload()
              })
              .catch((err) => {
                console.log(err.response);
                setError(err.response.statusText + " | May be you're offline.")
              })
          } else {
            setError("User doesn't exist in the database");
          }
        })
        .catch((err) => setError(err.response.statusText + " | May be you're offline."))
    }
  return (
    <div className="NewUserPopup" style={{ display }}>
      <div
        className="PopupTransparentBg"
        id="PopupTransparentBg"
        onClick={() => hidePopup()}
      ></div>
      <div className="NewUserContent">
        <div className="NewUserHeader">
          <Button onClick={() => hidePopup()} title="Close">
            <CancelOutlined />
          </Button>
        </div>
        <form
          action="/"
          method="POST"
          autoComplete="off"
          onSubmit={(e) => handleSubmit(e)}
        >
          {successMessage && (
            <div className="alert alert-success text-center" role="alert">
              {successMessage}
            </div>
          )}
          {error && <p className="my-3 error">{error}</p>}
          <div style={{ position: 'relative' }}>
            <input
              type="text"
              name="clientName"
              placeholder="Client Name"
              required
              onChange={(e) => handleChange(e)}
            />
            <input
              type="number"
              name="amountPaid"
              id="amountPaid"
              placeholder="Amount Paid"
              required
              onChange={(e) => handleChange(e)}
              min={0}
            />
            <label
              for="amountPaid"
              style={{
                position: 'absolute',
                top: '0.8rem',
                right: '1rem',
                fontFamily: 'Karla',
                fontWeight: 'bold',
              }}
            >
              USD
            </label>
          </div>
          <div>
            <input
              type="email"
              name="Email"
              placeholder="Email"
              required
              onChange={(e) => handleChange(e)}
            />
            <input
              type="number"
              name="maximumDownloads"
              placeholder="Maximum Downloads"
              required
              min={0}
              onChange={(e) => handleChange(e)}
            />
          </div>
          {/* <div style={{ justifyContent: "right" }}>
            <input
              type="number"
              name="maximumContentAccess"
              placeholder="Maximum Content Access"
              required
              onChange={(e) => handleChange(e)}
            />
          </div> */}
          <div>
            <input type="submit" value="Add Order" />
          </div>
        </form>
      </div>
    </div>
  )
}

export default NewOrder
